import { omit } from 'utilium';
/**
 * Standard POSIX error codes.
 * @see https://en.wikipedia.org/wiki/Errno.h
 */
export var Errno;
(function (Errno) {
    /** Operation not permitted */
    Errno[Errno["EPERM"] = 1] = "EPERM";
    /** No such file or directory */
    Errno[Errno["ENOENT"] = 2] = "ENOENT";
    /** No such process */
    Errno[Errno["ESRCH"] = 3] = "ESRCH";
    /** Interrupted system call */
    Errno[Errno["EINTR"] = 4] = "EINTR";
    /** Input/output error */
    Errno[Errno["EIO"] = 5] = "EIO";
    /** No such device or address */
    Errno[Errno["ENXIO"] = 6] = "ENXIO";
    /** Argument list too long */
    Errno[Errno["E2BIG"] = 7] = "E2BIG";
    /** Exec format error */
    Errno[Errno["ENOEXEC"] = 8] = "ENOEXEC";
    /** Bad file descriptor */
    Errno[Errno["EBADF"] = 9] = "EBADF";
    /** No child processes */
    Errno[Errno["ECHILD"] = 10] = "ECHILD";
    /** Resource temporarily unavailable */
    Errno[Errno["EAGAIN"] = 11] = "EAGAIN";
    /** Out of memory */
    Errno[Errno["ENOMEM"] = 12] = "ENOMEM";
    /** Permission denied */
    Errno[Errno["EACCES"] = 13] = "EACCES";
    /** Bad address */
    Errno[Errno["EFAULT"] = 14] = "EFAULT";
    /** Block device required */
    Errno[Errno["ENOTBLK"] = 15] = "ENOTBLK";
    /** Resource busy or locked */
    Errno[Errno["EBUSY"] = 16] = "EBUSY";
    /** File exists */
    Errno[Errno["EEXIST"] = 17] = "EEXIST";
    /** Invalid cross-device link */
    Errno[Errno["EXDEV"] = 18] = "EXDEV";
    /** No such device */
    Errno[Errno["ENODEV"] = 19] = "ENODEV";
    /** File is not a directory */
    Errno[Errno["ENOTDIR"] = 20] = "ENOTDIR";
    /** File is a directory */
    Errno[Errno["EISDIR"] = 21] = "EISDIR";
    /** Invalid argument */
    Errno[Errno["EINVAL"] = 22] = "EINVAL";
    /** Too many open files in system */
    Errno[Errno["ENFILE"] = 23] = "ENFILE";
    /** Too many open files */
    Errno[Errno["EMFILE"] = 24] = "EMFILE";
    /** Text file busy */
    Errno[Errno["ETXTBSY"] = 26] = "ETXTBSY";
    /** File is too big */
    Errno[Errno["EFBIG"] = 27] = "EFBIG";
    /** No space left on disk */
    Errno[Errno["ENOSPC"] = 28] = "ENOSPC";
    /** Illegal seek */
    Errno[Errno["ESPIPE"] = 29] = "ESPIPE";
    /** Cannot modify a read-only file system */
    Errno[Errno["EROFS"] = 30] = "EROFS";
    /** Too many links */
    Errno[Errno["EMLINK"] = 31] = "EMLINK";
    /** Broken pipe */
    Errno[Errno["EPIPE"] = 32] = "EPIPE";
    /** Numerical argument out of domain */
    Errno[Errno["EDOM"] = 33] = "EDOM";
    /** Numerical result out of range */
    Errno[Errno["ERANGE"] = 34] = "ERANGE";
    /** Resource deadlock would occur */
    Errno[Errno["EDEADLK"] = 35] = "EDEADLK";
    /** File name too long */
    Errno[Errno["ENAMETOOLONG"] = 36] = "ENAMETOOLONG";
    /** No locks available */
    Errno[Errno["ENOLCK"] = 37] = "ENOLCK";
    /** Function not implemented */
    Errno[Errno["ENOSYS"] = 38] = "ENOSYS";
    /** Directory is not empty */
    Errno[Errno["ENOTEMPTY"] = 39] = "ENOTEMPTY";
    /** Too many levels of symbolic links */
    Errno[Errno["ELOOP"] = 40] = "ELOOP";
    /** No message of desired type */
    Errno[Errno["ENOMSG"] = 42] = "ENOMSG";
    /** Identifier removed */
    Errno[Errno["EIDRM"] = 43] = "EIDRM";
    /** Channel number out of range */
    Errno[Errno["ECHRNG"] = 44] = "ECHRNG";
    /** Level 2 not synchronized */
    Errno[Errno["EL2NSYNC"] = 45] = "EL2NSYNC";
    /** Level 3 halted */
    Errno[Errno["EL3HLT"] = 46] = "EL3HLT";
    /** Level 3 reset */
    Errno[Errno["EL3RST"] = 47] = "EL3RST";
    /** Link number out of range */
    Errno[Errno["ENRNG"] = 48] = "ENRNG";
    /** Protocol driver not attached */
    Errno[Errno["EUNATCH"] = 49] = "EUNATCH";
    /** No CSI structure available */
    Errno[Errno["ECSI"] = 50] = "ECSI";
    /** Level 2 halted */
    Errno[Errno["EL2HLT"] = 51] = "EL2HLT";
    /** Invalid exchange */
    Errno[Errno["EBADE"] = 52] = "EBADE";
    /** Invalid request descriptor */
    Errno[Errno["EBADR"] = 53] = "EBADR";
    /** Exchange full */
    Errno[Errno["EXFULL"] = 54] = "EXFULL";
    /** No anode */
    Errno[Errno["ENOANO"] = 55] = "ENOANO";
    /** Invalid request code */
    Errno[Errno["EBADRQC"] = 56] = "EBADRQC";
    /** Invalid slot */
    Errno[Errno["EBADSLT"] = 57] = "EBADSLT";
    /** Bad font file format */
    Errno[Errno["EBFONT"] = 59] = "EBFONT";
    /** Device not a stream */
    Errno[Errno["ENOSTR"] = 60] = "ENOSTR";
    /** No data available */
    Errno[Errno["ENODATA"] = 61] = "ENODATA";
    /** Timer expired */
    Errno[Errno["ETIME"] = 62] = "ETIME";
    /** Out of streams resources */
    Errno[Errno["ENOSR"] = 63] = "ENOSR";
    /** Machine is not on the network */
    Errno[Errno["ENONET"] = 64] = "ENONET";
    /** Package not installed */
    Errno[Errno["ENOPKG"] = 65] = "ENOPKG";
    /** Object is remote */
    Errno[Errno["EREMOTE"] = 66] = "EREMOTE";
    /** Link has been severed */
    Errno[Errno["ENOLINK"] = 67] = "ENOLINK";
    /** Advertise error */
    Errno[Errno["EADV"] = 68] = "EADV";
    /** Srmount error */
    Errno[Errno["ESRMNT"] = 69] = "ESRMNT";
    /** Communication error on send */
    Errno[Errno["ECOMM"] = 70] = "ECOMM";
    /** Protocol error */
    Errno[Errno["EPROTO"] = 71] = "EPROTO";
    /** Multihop attempted */
    Errno[Errno["EMULTIHOP"] = 72] = "EMULTIHOP";
    /** RFS specific error */
    Errno[Errno["EDOTDOT"] = 73] = "EDOTDOT";
    /** Bad message */
    Errno[Errno["EBADMSG"] = 74] = "EBADMSG";
    /** Value too large for defined data type */
    Errno[Errno["EOVERFLOW"] = 75] = "EOVERFLOW";
    /** Name not unique on network */
    Errno[Errno["ENOTUNIQ"] = 76] = "ENOTUNIQ";
    /** File descriptor in bad state */
    Errno[Errno["EBADFD"] = 77] = "EBADFD";
    /** Remote address changed */
    Errno[Errno["EREMCHG"] = 78] = "EREMCHG";
    /** Can not access a needed shared library */
    Errno[Errno["ELIBACC"] = 79] = "ELIBACC";
    /** Accessing a corrupted shared library */
    Errno[Errno["ELIBBAD"] = 80] = "ELIBBAD";
    /** .lib section in a.out corrupted */
    Errno[Errno["ELIBSCN"] = 81] = "ELIBSCN";
    /** Attempting to link in too many shared libraries */
    Errno[Errno["ELIBMAX"] = 82] = "ELIBMAX";
    /** Cannot exec a shared library directly */
    Errno[Errno["ELIBEXEC"] = 83] = "ELIBEXEC";
    /** Invalid or incomplete multibyte or wide character */
    Errno[Errno["EILSEQ"] = 84] = "EILSEQ";
    /** Interrupted system call should be restarted */
    Errno[Errno["ERESTART"] = 85] = "ERESTART";
    /** Streams pipe error */
    Errno[Errno["ESTRPIPE"] = 86] = "ESTRPIPE";
    /** Too many users */
    Errno[Errno["EUSERS"] = 87] = "EUSERS";
    /** Socket operation on non-socket */
    Errno[Errno["ENOTSOCK"] = 88] = "ENOTSOCK";
    /** Destination address required */
    Errno[Errno["EDESTADDRREQ"] = 89] = "EDESTADDRREQ";
    /** Message too long */
    Errno[Errno["EMSGSIZE"] = 90] = "EMSGSIZE";
    /** Protocol wrong type for socket */
    Errno[Errno["EPROTOTYPE"] = 91] = "EPROTOTYPE";
    /** Protocol not available */
    Errno[Errno["ENOPROTOOPT"] = 92] = "ENOPROTOOPT";
    /** Protocol not supported */
    Errno[Errno["EPROTONOSUPPORT"] = 93] = "EPROTONOSUPPORT";
    /** Socket type not supported */
    Errno[Errno["ESOCKTNOSUPPORT"] = 94] = "ESOCKTNOSUPPORT";
    /** Operation is not supported */
    Errno[Errno["ENOTSUP"] = 95] = "ENOTSUP";
    /** Protocol family not supported */
    Errno[Errno["EPFNOSUPPORT"] = 96] = "EPFNOSUPPORT";
    /** Address family not supported by protocol */
    Errno[Errno["EAFNOSUPPORT"] = 97] = "EAFNOSUPPORT";
    /** Address already in use */
    Errno[Errno["EADDRINUSE"] = 98] = "EADDRINUSE";
    /** Cannot assign requested address */
    Errno[Errno["EADDRNOTAVAIL"] = 99] = "EADDRNOTAVAIL";
    /** Network is down */
    Errno[Errno["ENETDOWN"] = 100] = "ENETDOWN";
    /** Network is unreachable */
    Errno[Errno["ENETUNREACH"] = 101] = "ENETUNREACH";
    /** Network dropped connection on reset */
    Errno[Errno["ENETRESET"] = 102] = "ENETRESET";
    /** Software caused connection abort */
    Errno[Errno["ECONNABORTED"] = 103] = "ECONNABORTED";
    /** Connection reset by peer */
    Errno[Errno["ECONNRESET"] = 104] = "ECONNRESET";
    /** No buffer space available */
    Errno[Errno["ENOBUFS"] = 105] = "ENOBUFS";
    /** Transport endpoint is already connected */
    Errno[Errno["EISCONN"] = 106] = "EISCONN";
    /** Transport endpoint is not connected */
    Errno[Errno["ENOTCONN"] = 107] = "ENOTCONN";
    /** Cannot send after transport endpoint shutdown */
    Errno[Errno["ESHUTDOWN"] = 108] = "ESHUTDOWN";
    /** Too many references: cannot splice */
    Errno[Errno["ETOOMANYREFS"] = 109] = "ETOOMANYREFS";
    /** Connection timed out */
    Errno[Errno["ETIMEDOUT"] = 110] = "ETIMEDOUT";
    /** Connection refused */
    Errno[Errno["ECONNREFUSED"] = 111] = "ECONNREFUSED";
    /** Host is down */
    Errno[Errno["EHOSTDOWN"] = 112] = "EHOSTDOWN";
    /** No route to host */
    Errno[Errno["EHOSTUNREACH"] = 113] = "EHOSTUNREACH";
    /** Operation already in progress */
    Errno[Errno["EALREADY"] = 114] = "EALREADY";
    /** Operation now in progress */
    Errno[Errno["EINPROGRESS"] = 115] = "EINPROGRESS";
    /** Stale file handle */
    Errno[Errno["ESTALE"] = 116] = "ESTALE";
    /** Structure needs cleaning */
    Errno[Errno["EEUCLEAN"] = 117] = "EEUCLEAN";
    /** Not a XENIX named type file */
    Errno[Errno["ENOTNAM"] = 118] = "ENOTNAM";
    /** No XENIX semaphores available */
    Errno[Errno["ENAVAIL"] = 119] = "ENAVAIL";
    /** Is a named type file */
    Errno[Errno["EISNAM"] = 120] = "EISNAM";
    /** Remote I/O error */
    Errno[Errno["EREMOTEIO"] = 121] = "EREMOTEIO";
    /** Disk quota exceeded */
    Errno[Errno["EDQUOT"] = 122] = "EDQUOT";
    /** No medium found */
    Errno[Errno["ENOMEDIUM"] = 123] = "ENOMEDIUM";
    /** Wrong medium type */
    Errno[Errno["EMEDIUMTYPE"] = 124] = "EMEDIUMTYPE";
    /** Operation canceled */
    Errno[Errno["ECANCELED"] = 125] = "ECANCELED";
    /** Required key not available */
    Errno[Errno["ENOKEY"] = 126] = "ENOKEY";
    /** Key has expired */
    Errno[Errno["EKEYEXPIRED"] = 127] = "EKEYEXPIRED";
    /** Key has been revoked */
    Errno[Errno["EKEYREVOKED"] = 128] = "EKEYREVOKED";
    /** Key was rejected by service */
    Errno[Errno["EKEYREJECTED"] = 129] = "EKEYREJECTED";
    /** Owner died */
    Errno[Errno["EOWNERDEAD"] = 130] = "EOWNERDEAD";
    /** State not recoverable */
    Errno[Errno["ENOTRECOVERABLE"] = 131] = "ENOTRECOVERABLE";
    /** Operation not possible due to RF-kill */
    Errno[Errno["ERFKILL"] = 132] = "ERFKILL";
    /** Memory page has hardware error */
    Errno[Errno["EHWPOISON"] = 133] = "EHWPOISON";
})(Errno || (Errno = {}));
/**
 * Strings associated with each error code.
 * @internal
 */
const errnoMessages = {
    [Errno.EPERM]: 'operation not permitted',
    [Errno.ENOENT]: 'no such file or directory',
    [Errno.ESRCH]: 'no such process',
    [Errno.EINTR]: 'interrupted system call',
    [Errno.EIO]: 'i/o error',
    [Errno.ENXIO]: 'no such device or address',
    [Errno.E2BIG]: 'argument list too long',
    [Errno.ENOEXEC]: 'exec format error',
    [Errno.EBADF]: 'bad file descriptor',
    [Errno.ECHILD]: 'no child processes',
    [Errno.EAGAIN]: 'resource temporarily unavailable',
    [Errno.ENOMEM]: 'not enough memory',
    [Errno.EACCES]: 'permission denied',
    [Errno.EFAULT]: 'bad address in system call argument',
    [Errno.ENOTBLK]: 'block device required',
    [Errno.EBUSY]: 'resource busy or locked',
    [Errno.EEXIST]: 'file already exists',
    [Errno.EXDEV]: 'cross-device link not permitted',
    [Errno.ENODEV]: 'no such device',
    [Errno.ENOTDIR]: 'not a directory',
    [Errno.EISDIR]: 'illegal operation on a directory',
    [Errno.EINVAL]: 'invalid argument',
    [Errno.ENFILE]: 'file table overflow',
    [Errno.EMFILE]: 'too many open files',
    [Errno.ETXTBSY]: 'text file is busy',
    [Errno.EFBIG]: 'file too large',
    [Errno.ENOSPC]: 'no space left on device',
    [Errno.ESPIPE]: 'invalid seek',
    [Errno.EROFS]: 'read-only file system',
    [Errno.EMLINK]: 'too many links',
    [Errno.EPIPE]: 'broken pipe',
    [Errno.EDOM]: 'numerical argument out of domain',
    [Errno.ERANGE]: 'result too large',
    [Errno.EDEADLK]: 'resource deadlock would occur',
    [Errno.ENAMETOOLONG]: 'name too long',
    [Errno.ENOLCK]: 'no locks available',
    [Errno.ENOSYS]: 'function not implemented',
    [Errno.ENOTEMPTY]: 'directory not empty',
    [Errno.ELOOP]: 'too many symbolic links encountered',
    [Errno.ENOMSG]: 'no message of desired type',
    [Errno.EIDRM]: 'identifier removed',
    [Errno.ECHRNG]: 'channel number out of range',
    [Errno.EL2NSYNC]: 'level 2 not synchronized',
    [Errno.EL3HLT]: 'level 3 halted',
    [Errno.EL3RST]: 'level 3 reset',
    [Errno.ENRNG]: 'link number out of range',
    [Errno.EUNATCH]: 'protocol driver not attached',
    [Errno.ECSI]: 'no CSI structure available',
    [Errno.EL2HLT]: 'level 2 halted',
    [Errno.EBADE]: 'invalid exchange',
    [Errno.EBADR]: 'invalid request descriptor',
    [Errno.EXFULL]: 'exchange full',
    [Errno.ENOANO]: 'no anode',
    [Errno.EBADRQC]: 'invalid request code',
    [Errno.EBADSLT]: 'invalid slot',
    [Errno.EBFONT]: 'bad font file format',
    [Errno.ENOSTR]: 'device not a stream',
    [Errno.ENODATA]: 'no data available',
    [Errno.ETIME]: 'timer expired',
    [Errno.ENOSR]: 'out of streams resources',
    [Errno.ENONET]: 'machine is not on the network',
    [Errno.ENOPKG]: 'package not installed',
    [Errno.EREMOTE]: 'object is remote',
    [Errno.ENOLINK]: 'link has been severed',
    [Errno.EADV]: 'advertise error',
    [Errno.ESRMNT]: 'srmount error',
    [Errno.ECOMM]: 'communication error on send',
    [Errno.EPROTO]: 'protocol error',
    [Errno.EMULTIHOP]: 'multihop attempted',
    [Errno.EDOTDOT]: 'rFS specific error',
    [Errno.EBADMSG]: 'bad message',
    [Errno.EOVERFLOW]: 'value too large for defined data type',
    [Errno.ENOTUNIQ]: 'name not unique on network',
    [Errno.EBADFD]: 'file descriptor in bad state',
    [Errno.EREMCHG]: 'remote address changed',
    [Errno.ELIBACC]: 'can not access a needed shared library',
    [Errno.ELIBBAD]: 'accessing a corrupted shared library',
    [Errno.ELIBSCN]: '.lib section in a.out corrupted',
    [Errno.ELIBMAX]: 'attempting to link in too many shared libraries',
    [Errno.ELIBEXEC]: 'cannot exec a shared library directly',
    [Errno.EILSEQ]: 'illegal byte sequence',
    [Errno.ERESTART]: 'interrupted system call should be restarted',
    [Errno.ESTRPIPE]: 'streams pipe error',
    [Errno.EUSERS]: 'too many users',
    [Errno.ENOTSOCK]: 'socket operation on non-socket',
    [Errno.EDESTADDRREQ]: 'destination address required',
    [Errno.EMSGSIZE]: 'message too long',
    [Errno.EPROTOTYPE]: 'protocol wrong type for socket',
    [Errno.ENOPROTOOPT]: 'protocol not available',
    [Errno.EPROTONOSUPPORT]: 'protocol not supported',
    [Errno.ESOCKTNOSUPPORT]: 'socket type not supported',
    [Errno.ENOTSUP]: 'operation not supported on socket',
    [Errno.EPFNOSUPPORT]: 'protocol family not supported',
    [Errno.EAFNOSUPPORT]: 'address family not supported',
    [Errno.EADDRINUSE]: 'address already in use',
    [Errno.EADDRNOTAVAIL]: 'address not available',
    [Errno.ENETDOWN]: 'network is down',
    [Errno.ENETUNREACH]: 'network is unreachable',
    [Errno.ENETRESET]: 'network dropped connection on reset',
    [Errno.ECONNABORTED]: 'software caused connection abort',
    [Errno.ECONNRESET]: 'connection reset by peer',
    [Errno.ENOBUFS]: 'no buffer space available',
    [Errno.EISCONN]: 'socket is already connected',
    [Errno.ENOTCONN]: 'socket is not connected',
    [Errno.ESHUTDOWN]: 'cannot send after transport endpoint shutdown',
    [Errno.ETOOMANYREFS]: 'too many references: cannot splice',
    [Errno.ETIMEDOUT]: 'connection timed out',
    [Errno.ECONNREFUSED]: 'connection refused',
    [Errno.EHOSTDOWN]: 'host is down',
    [Errno.EHOSTUNREACH]: 'host is unreachable',
    [Errno.EALREADY]: 'connection already in progress',
    [Errno.EINPROGRESS]: 'operation now in progress',
    [Errno.ESTALE]: 'stale file handle',
    [Errno.EEUCLEAN]: 'structure needs cleaning',
    [Errno.ENOTNAM]: 'not a XENIX named type file',
    [Errno.ENAVAIL]: 'no XENIX semaphores available',
    [Errno.EISNAM]: 'is a named type file',
    [Errno.EREMOTEIO]: 'remote I/O error',
    [Errno.EDQUOT]: 'disk quota exceeded',
    [Errno.ENOMEDIUM]: 'no medium found',
    [Errno.EMEDIUMTYPE]: 'wrong medium type',
    [Errno.ECANCELED]: 'operation canceled',
    [Errno.ENOKEY]: 'required key not available',
    [Errno.EKEYEXPIRED]: 'key has expired',
    [Errno.EKEYREVOKED]: 'key has been revoked',
    [Errno.EKEYREJECTED]: 'key was rejected by service',
    [Errno.EOWNERDEAD]: 'owner died',
    [Errno.ENOTRECOVERABLE]: 'state not recoverable',
    [Errno.ERFKILL]: 'operation not possible due to RF-kill',
    [Errno.EHWPOISON]: 'memory page has hardware error',
};
export function strerror(errno) {
    const _errno = typeof errno == 'string' ? Errno[errno] : errno;
    return (_errno in errnoMessages ? errnoMessages[_errno] : '');
}
/**
 * Set the message of an exception to the UV-style message.
 */
export function setUVMessage(ex) {
    let message = `${ex.code}: ${errnoMessages[ex.errno]}, ${ex.syscall}`;
    if (ex.path)
        message += ` '${ex.path}'`;
    if (ex.dest)
        message += ` -> '${ex.dest}'`;
    const isDefault = ex.message.startsWith(errnoMessages[ex.errno]) || /^E[A-Z0-9]+: /.test(ex.message);
    if (ex.message && !isDefault)
        message += ` (${ex.message})`;
    ex.message = message;
    return ex;
}
/**
 * An error with additional information about what happened.
 *
 * @privateRemarks
 *
 * This is modeled after Node.js's `ErrnoException` and `UVException`.
 *
 * `Error.captureStackTrace` is used when available to hide irrelevant stack frames.
 * This is being standardized, however it is not available in Deno and behind a flag in Firefox.
 * See https://github.com/tc39/proposal-error-capturestacktrace for more details.
 */
export class Exception extends Error {
    errno;
    code;
    path;
    dest;
    syscall;
    constructor(errno, message, ctx = {}) {
        const code = Errno[errno];
        super(message || '');
        this.errno = errno;
        this.code = code;
        Object.assign(this, omit(ctx, 'message'));
        if (!message)
            setUVMessage(this);
        Error.captureStackTrace?.(this, this.constructor);
    }
    toString() {
        return this.message;
    }
    toJSON() {
        const json = {
            errno: this.errno,
            code: this.code,
            stack: this.stack,
            message: this.message,
        };
        if (this.path)
            json.path = this.path;
        if (this.dest)
            json.dest = this.dest;
        if (this.syscall)
            json.syscall = this.syscall;
        return json;
    }
    static fromJSON(json) {
        const err = json.syscall ? new Exception(json.errno, false, json) : new Exception(json.errno, json.message);
        err.stack = json.stack;
        return err;
    }
}
export function UV(code, context, path, dest) {
    if (typeof context === 'string')
        context = { syscall: context, path, dest };
    const err = new Exception(Errno[code], false, context ?? {});
    Error.captureStackTrace?.(err, UV);
    return err;
}
/**
 * Shortcut to easily create an `Exception` with a specific error code.
 */
export function withErrno(code, message) {
    const err = new Exception(Errno[code], message ?? errnoMessages[Errno[code]]);
    Error.captureStackTrace?.(err, withErrno);
    return err;
}
export function rethrow(extra, path, dest) {
    const ctx = typeof extra === 'string' ? { syscall: extra } : extra;
    if (path)
        ctx.path = path;
    if (dest)
        ctx.dest = dest;
    return function (e) {
        Object.assign(e, ctx);
        setUVMessage(e);
        throw e;
    };
}
